
export const checkAuth = () => {
    const localStorageValue = localStorage.getItem("authToken");

    return !!localStorageValue;
}
